<div [class]="className" [style.bottom]="bottom" [style.right]="right">
    <i nz-icon class="notification-type" nzTheme="outline" [nzType]="icon"></i>
    <div class="notification-content">
        <i nz-icon nzType="close" nzTheme="outline" class="notification-close" (click)="close()"></i>
        <div class="notification-title">{{ title || defaultTitle }}</div>
        <div class="notification-message">{{ message }}</div>
    </div>
</div>
